<template>
  <component :is="eventKey" v-if="eventKey" v-model="filters" />
</template>

<script lang="ts">
import { computed } from 'vue'
import BalanceCrossed from './filters/BalanceCrossed.vue'
import CampaignLimitReached from './filters/CampaignLimitReached.vue'

export default {
  components: { BalanceCrossed, CampaignLimitReached },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    eventKey: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const filters = computed({
      get: () => {
        return props.modelValue
      },
      set: (val) => {
        context.emit('update:modelValue', val)
      }
    })

    return {
      filters
    }
  }
}
</script>

<style>
.input-with-select .el-input-group__prepend {
  background-color: var(--el-fill-color-blank);
}
.event-filters {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
